import React, { useContext, FC, ReactNode } from "react";
import styled from "styled-components";
import { SidebarContext } from "./context/SidebarMenuProvider";
import { Spin } from "antd";

interface MainContainerProps {
	children: ReactNode;
}
interface StyledContainerProps {
	isSidebarOpen: boolean;
}

const StyledContainer = styled.div<StyledContainerProps>`
	margin: 130px 40px auto 0;
	transition: margin-left 0.3s ease;
	margin-left: ${({ isSidebarOpen }) => (isSidebarOpen ? '120px' : '320px')};
`;

const MainContainer: FC<MainContainerProps> = ({ children }) => {
	const { isLoading, isSidebarOpen } = useContext(SidebarContext);
	return (
		<Spin spinning={isLoading} >
			<StyledContainer isSidebarOpen={isSidebarOpen}>
				{children}
			</StyledContainer>
		</Spin>
	);
};

export default MainContainer;
